<div class="rating-block">
  <h2 [tabIndex]="0">{{ 'comments.ratings' | translate }}</h2>

  <div class="rating-block__body">
    <div class="rating-block__body__left">
      <span class="rating-block__body__left__number">{{ rating.mean | number: '1.1-1' }}</span>
      <app-rating [mean]="rating.mean" [readOnly]="true"></app-rating>

      <p class="rating-block__body__left__total" *ngIf="rating.totalRatings">
        {{ rating.totalRatings }}
        <span [ngPlural]="rating.totalRatings">
          <ng-template ngPluralCase="=1">{{ 'comments.singularRating' | translate }}</ng-template>
          <ng-template ngPluralCase="other">{{ 'comments.pluralRating' | translate }}</ng-template>
        </span>
      </p>
    </div>

    <div class="rating-block__body__right" [attr.dir]="textDirection">
      <div class="rating-block__body__right__row">
        <div class="row__stars">
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
        </div>

        <div class="row__bar">
          <mat-progress-bar mode="determinate" [value]="fiveBarValue"></mat-progress-bar>
          <span class="row__bar__number">{{ rating.fiveStars }}</span>
        </div>
      </div>

      <div class="rating-block__body__right__row">
        <div class="row__stars">
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon">star_black</span>
        </div>

        <div class="row__bar">
          <mat-progress-bar mode="determinate" [value]="fourBarValue"></mat-progress-bar>
          <span class="row__bar__number">{{ rating.fourStars }}</span>
        </div>
      </div>

      <div class="rating-block__body__right__row">
        <div class="row__stars">
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
        </div>

        <div class="row__bar">
          <mat-progress-bar mode="determinate" [value]="threeBarValue"></mat-progress-bar>
          <span class="row__bar__number">{{ rating.threeStars }}</span>
        </div>
      </div>

      <div class="rating-block__body__right__row">
        <div class="row__stars">
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
        </div>

        <div class="row__bar">
          <mat-progress-bar mode="determinate" [value]="twoBarValue"></mat-progress-bar>
          <span class="row__bar__number">{{ rating.twoStars }}</span>
        </div>
      </div>

      <div class="rating-block__body__right__row">
        <div class="row__stars">
          <span class="odilo-icon full">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
          <span class="odilo-icon">star_black</span>
        </div>

        <div class="row__bar">
          <mat-progress-bar mode="determinate" [value]="oneBarValue"></mat-progress-bar>
          <span class="row__bar__number">{{ rating.oneStar }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
